/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import employeeAppIcon from '../assets/employeeAppIcon.png'
import phoneIdentityView from '../assets/phone-identity-view.png'

interface Props {
  code: string
}
function IdentityCodePreview(props: Props) {
  const { code } = props

  return (
    <Grid container justifyContent={'center'}>
      <div
        css={css`
          margin-right: 20px;
          width: 300px;
        `}
      >
        <img
          src={employeeAppIcon}
          alt="User App Icon"
          css={css`
            width: 66px;
            height: 66px;
          `}
        />
        <Typography
          css={css`
            font-weight: 600;
            font-size: 22px;
            line-height: 33px;
          `}
        >
          Open your Reaction Club app and enter the following code:
        </Typography>

        <Typography
          css={css`
            font-weight: 600;
            font-size: 80px;
            line-height: 100px;
            color: #f8b22f;
          `}
        >
          {code}
        </Typography>
      </div>
      <div>
        <img
          src={phoneIdentityView}
          alt="mobile side preview"
          css={css`
            width: 125px;
            height: 270px;
          `}
        />
      </div>
    </Grid>
  )
}

export default IdentityCodePreview
